import { PageTitle } from '@/utils/pageTitle';
import { Container } from '@mui/material';
import ProductRatingsProvider from '@/contexts/ProductRatingsContext';
import ProductReviewsPanel from '@/sections/@dashboard/product-reviews/ProductReviewsPanel';

export default function ProductRatings() {
  return (
    <>
      <PageTitle area="Produtos" screen="Avaliações de Clientes" />

      <Container maxWidth="lg" sx={{ pt: 3, pb: 4 }}>
        <ProductRatingsProvider>
          <ProductReviewsPanel />
        </ProductRatingsProvider>
      </Container>
    </>
  );
}
